import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './styles/TabbedView.css'

const Tab = ({ tab: { label, disabled }, selected, onClick, className }) => (
  <button
    className={classNames(className, styles.tab, {
      [styles.tabSelected]: selected
    })}
    onClick={e => {
      e.target.blur()

      onClick(e)
    }}
    tabIndex='0'
    disabled={disabled}
  >
    {label}
  </button>
)

const TabbedView = ({ className, viewClassName, tabBarClassName, tabClassName, tabSelectedClassName, tabs, selected = 0, onSelected }) => {
  const { view } = tabs[selected] || tabs.find(tab => tab.id === selected)

  return (
    <div className={className}>
      <div className={classNames(styles.tabBar, tabBarClassName)}>
        {tabs.map((tab, index) =>
          <Tab
            className={classNames(tabClassName, {
              [tabSelectedClassName]: index === selected || selected === tab.id
            })}
            key={index}
            tab={tab}
            onClick={() => onSelected(index, tab.id)}
            selected={selected === index || selected === tab.id}
          />
        )}
      </div>
      <div className={classNames(styles.view, viewClassName)}>
        {view()}
      </div>
    </div>
  )
}

TabbedView.propTypes = {
  tabs: PropTypes.array.isRequired,
  selected: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  onSelected: PropTypes.func.isRequired,
  className: PropTypes.string,
  viewClassName: PropTypes.string
}

export default TabbedView
